import HomeGuard from './Home.guard';
export default [
    {
        name: 'view',
        path: '/',
        component: () => import('./Home').then(m => m.default),
        afterActivate: HomeGuard
    }
];
